module.exports = __webpack_public_path__ + "img/Branding.876e7ec9.svg";